var DeleteCandidateDocumentController = /** @class */ (function () {
    /*@ngInject*/
    function DeleteCandidateDocumentController($rootScope, MESSAGECONSTANTS, documentService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.documentService = documentService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    DeleteCandidateDocumentController.prototype.$onInit = function () {
        this.savingFlag = false;
        this.deleteLatestVersion = true;
    };
    DeleteCandidateDocumentController.prototype.delete = function () {
        var _this = this;
        this.savingFlag = true;
        this.deleteDocumentPayload.keepLastVersion = this.deleteLatestVersion;
        this.documentService.deleteCandidateDocument(this.deleteDocumentPayload, function () {
            _this.savingFlag = false;
            if (_this.saveCallback) {
                _this.saveCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
        });
    };
    DeleteCandidateDocumentController.prototype.cancel = function () {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    };
    return DeleteCandidateDocumentController;
}());
DeleteCandidateDocumentController.$inject = ['$rootScope', 'MESSAGECONSTANTS', 'documentService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './delete-candidate-document.html';
import * as TEMPLATE from 'raw-loader!./delete-candidate-document.html';
export var DeleteCandidateDocumentComponent = {
    selector: 'deleteCandidateDocument',
    component: {
        bindings: {
            document: '<',
            deleteDocumentPayload: '<',
            saveCallback: '&',
            cancelCallback: '&'
        },
        controller: DeleteCandidateDocumentController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/deleteCandidateDocument/delete-candidate-document.html'
    }
};
//# sourceMappingURL=delete-candidate-document.component.js.map